module.exports = __webpack_public_path__ + "static/media/Olive.a40a72f1.png";